import { gql } from "@apollo/client";

export const GET_VM_COST_ANALYSIS = gql`
  query GetVmCostAnalysis($vmId: ID!) {
    getVmCostAnalysis(vmId: $vmId) {
      id
      vmId
      vmName
      summary
      previousMonth
      currentMonth
      monthOverMonthChange
      monthOverMonthDirection
      changeCause
      averageMonthly
      peakMonth
      lowestMonth
      trend
      reservationSavingsPercent
      sharedCostPercent
      predictedNextMonth
      predictedTotal
      predictedChangePercent
      predictedDirection
      predictionConfidence
      recommendationAction
      recommendationSuggestion
      createdAt
    }
  }
`;

export const GET_ALL_VM_COST_ANALYSES = gql`
  query GetAllVmCostAnalyses {
    getAllVmCostAnalyses {
      id
      vmId
      vmName
      summary
      averageMonthly
      peakMonth
      lowestMonth
      trend
      predictedNextMonth
      predictedTotal
      recommendationAction
      createdAt
    }
  }
`;

export const ANALYZE_ALL_VM_COSTS = gql`
  mutation AnalyzeAllVmCosts {
    analyzeAllVmCosts
  }
`;
